
import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'Michael Rodriguez',
      position: 'CEO, Houston Energy Corp',
      text: 'Regal Sprinter transformed our corporate transportation experience. The Maybach Sprinter was immaculate, and our chauffeur was exceptionally professional. Highly recommend for executive travel.',
      rating: 5
    },
    {
      name: 'Sarah Johnson',
      position: 'Event Coordinator, Premier Weddings',
      text: 'We use Regal Sprinter for all our high-end wedding transportation. Their attention to detail and luxury vehicles make every celebration special. Our clients absolutely love them!',
      rating: 5
    },
    {
      name: 'David Chen',
      position: 'Director of Operations, Tech Innovations',
      text: 'Outstanding service from start to finish. The WiFi and dual TVs made our team meeting productive during transit. Regal Sprinter is now our go-to for all corporate events.',
      rating: 5
    },
    {
      name: 'Jennifer Martinez',
      position: 'Travel Manager, Global Solutions Inc',
      text: 'Punctual, professional, and luxurious. Regal Sprinter handles all our airport transfers and the service is consistently excellent. The vehicles are pristine and drivers are courteous.',
      rating: 5
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section id="testimonials" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="text-sm font-bold text-gray-500 uppercase tracking-widest mb-3">TESTIMONIALS</div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            What Our Clients Say
          </h2>
          <p className="text-base lg:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Don't just take our word for it. Hear from our satisfied clients who have experienced the Regal Sprinter difference.
          </p>
        </div>

        <div className="relative bg-black rounded-3xl overflow-hidden mx-4 lg:mx-20">
          <div className="p-10 lg:p-16 flex flex-col items-center text-center">
            <div className="text-amber-400 text-7xl lg:text-9xl mb-6 leading-none">"</div>
            
            <div className="flex mb-6">
              {[...Array(currentTestimonial.rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-2xl text-amber-400"></i>
              ))}
            </div>

            <p className="text-xl lg:text-2xl xl:text-3xl text-white leading-relaxed mb-10 font-light max-w-4xl">
              {currentTestimonial.text}
            </p>

            <div className="mb-10">
              <div className="text-xl font-bold text-white mb-1">{currentTestimonial.name}</div>
              <div className="text-base text-gray-400">{currentTestimonial.position}</div>
            </div>

            <div className="flex items-center space-x-4">
              <button 
                onClick={prevTestimonial}
                className="w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-white text-xl"></i>
              </button>
              <div className="text-white text-sm">
                {currentIndex + 1} / {testimonials.length}
              </div>
              <button 
                onClick={nextTestimonial}
                className="w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-white text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
